export default __webpack_public_path__ + "static/media/Bonesever.62eff2ef.jpg";